class StickyCheckout extends HTMLElement {
  constructor() {
    super();
    this.sticky = this.querySelector('[data-sticky-checkout]');
    this.summary = document.querySelector('.cart-page__summary');
    this.mq = window.matchMedia('(max-width: 1119px)');
    this.io = null;
  }

  connectedCallback() {
    if (!this.sticky || !this.summary) return;

    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.update(!(entry.isIntersecting && entry.intersectionRatio > 0));
        });
      },
      { rootMargin: '0px 0px -20% 0px', threshold: [0, 0.01, 0.1] }
    );

    this.handleMQ = this.handleMQ.bind(this);
    this.handleMQ();
    this.mq.addEventListener ? this.mq.addEventListener('change', this.handleMQ) : this.mq.addListener(this.handleMQ);
  }

  disconnectedCallback() {
    if (this.io) {
      this.io.disconnect();
    }
    this.mq.removeEventListener ? this.mq.removeEventListener('change', this.handleMQ) : this.mq.removeListener(this.handleMQ);
  }

  update(show) {
    if (show) {
      this.sticky.classList.add('is-visible');
      this.sticky.classList.remove('is-hidden');
    } else {
      this.sticky.classList.remove('is-visible');
      this.sticky.classList.add('is-hidden');
    }
  }

  handleMQ() {
    if (this.mq.matches) {
      this.update(true);
      this.io.observe(this.summary);
    } else {
      this.update(false);
      this.io.unobserve(this.summary);
    }
  }
}

customElements.define('sticky-checkout', StickyCheckout);
